import {SURVEY_ROOT} from '@router/consts';
import {Redirect} from 'react-router-dom';

export const RedirectSurvey = () => <Redirect to={SURVEY_ROOT} />;
